import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { useEffect } from 'react';

export const Route = createFileRoute('/projects/$projectId')({
  component: RouteComponent,
});

function RouteComponent() {
  const navigate = useNavigate();
  const params = Route.useParams();

  useEffect(() => {
    navigate({
      to: '/integrations/$projectId',
      params: { projectId: params.projectId },
      replace: true,
      search: {},
      from: '/projects/$projectId',
    });
  }, [navigate, params.projectId]);

  return null;
}
